import React, { } from 'react';

function Error() {
  return (
    <div>
      <h1>Error: User Not Found</h1>
      <p>The user you are looking for does not exist.</p>
    </div>
  );
}
export default Error;